import React from 'react';
import './GalleryPage.css';
import galleryImg from './imagesGallery/aboutpage.png';

const GalleryPage = () => {
  return (
     <div className='gallery-section'>
            <div className='page'> 
          <img src={galleryImg} alt=''/>
          </div>
          </div>
  )
}

export default GalleryPage
